import { render, staticRenderFns } from "./FormatGemeenten.vue?vue&type=template&id=ad0ad47e&scoped=true"
import script from "./FormatGemeenten.vue?vue&type=script&lang=js"
export * from "./FormatGemeenten.vue?vue&type=script&lang=js"
import style0 from "./FormatGemeenten.vue?vue&type=style&index=0&id=ad0ad47e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0ad47e",
  null
  
)

export default component.exports